import { FC } from "react";
import styled from "styled-components";
import { pageSizeValues } from "../../configuration/selectValues";
import { useTheme } from "../../../features/context/CustomerContext";
import useCustomTranslation from "../../../features/hooks/CustomUseTranslation";

const PageSizeSelectionWrapper = styled.div`
    display: flex;
    margin-bottom: 20px;
    float: left;
    padding-left: 10px;
`
const PageSizeSelectionTitle = styled.label`
    padding-right: 10px;
`
const Select = styled.select`
    border: none;
    color: ${(props) => props.theme.brandColor1};
    margin-left: 5px;
`

interface PageSizeSelectionProps {
    pageSize: number;
    pageSizeChange: (newPageSize: number) => void;
}
const PageSizeSelection:FC<PageSizeSelectionProps> = (props) => {
    const { t } = useCustomTranslation();
    const theme = useTheme();

    return(
        <PageSizeSelectionWrapper>

            <PageSizeSelectionTitle htmlFor="pageSizeSelect">{t("Rows per page: ")}</PageSizeSelectionTitle>

            <Select theme={theme} id="pageSizeSelect" value={props.pageSize} onChange={(e) =>  props.pageSizeChange(parseInt(e.target.value)) }>
                {pageSizeValues.map(applicationPageSizeValue => (
                    <option key={applicationPageSizeValue.value} value={applicationPageSizeValue.value}>{applicationPageSizeValue.value}</option>
                ))}
            </Select>

        </PageSizeSelectionWrapper>
    )
}

export default PageSizeSelection;